export default "__VITE_ASSET__Dv5crI6T__"